import s from '../Menu/Menu.module.scss';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/Header/Header';

const BrandsHub = () => {
  const navigate = useNavigate();
  const items = [
    { title: 'Соотнести бренды', link: '/brands/compare' },
    { title: 'Источник товаров', link: '/brands/price-sources' },
    { title: 'Бренды с РРЦ', link: '/brands/use-rrp' },
  ];

  return (
    <>
      <Header
        title="Бренды и API"
        breadCrumbs={[
          { name: 'Главная', link: '/' },
          { name: 'Бренды и API', link: '/brands' },
        ]}
      />
      <div>
        <div className={s.menu}>
          {items.map((item, i) => (
            <div key={i} className={s.item} onClick={() => navigate(item.link)}>
              <h3>{item.title}</h3>
              <button
                className="btn grey"
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(item.link);
                }}
              >
                Перейти
              </button>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default BrandsHub;
